import { styled, css } from 'styled-components';

export const Pill = styled.div<{$hasHover: boolean}>`
  color: #070707;
  font-family: Inter;
  font-size: 12px;
  background-color: ${({ theme }) => theme.colors.pillbutton.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 500px;
  padding: 4px 12px;

  ${({ $hasHover }) => $hasHover && css`
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: ${({ theme }) => theme.colors.button.hover.primary};
    }
  `}
`;
